// src/confluence/site/types.ts
var ConfluenceSiteAriResourceOwner = "confluence", ConfluenceSiteAriResourceType = "site";

export {
  ConfluenceSiteAriResourceOwner,
  ConfluenceSiteAriResourceType
};
